import { navigateTo } from "../../routing";
import { NavigationType } from "../../stores/session";
import { saveUserSettings } from "../../apiLoader/user";
import { getUploadUrl, uploadFile as uploadFileAPICall } from "../../apiLoader/upload";
import { get } from "svelte/store";
import { settingsStore } from "../../stores/settings";
import { MAX_FILE_SIZES } from "../../constants/upload";

export const uploadFile = async (file: File) => {
  const { url, fields } = await getUploadUrl(file.type);
  await uploadFileAPICall(file, fields, url);
  return fields.key;
};

export const saveUploadedFileToUserSettings = async (file: string) => saveUserSettings({ file_upload: file });
export const completeFileUpload = () => navigateTo(NavigationType.Next);

export const validateSelectedFile = (selectedFile: File): void => {
  const mimeType = selectedFile.type;
  const fileType = mimeType.split("/")[0];
  const maxFileSize = MAX_FILE_SIZES[fileType] ?? MAX_FILE_SIZES.default;
  const uploadMimeTypes: string[] = get(settingsStore).uploadMimeTypes ?? [];

  if (!uploadMimeTypes.includes(mimeType)) {
    throw new Error("Invalid file type. Please select an image file.", {
      cause: {
        type: "INVALID_FILE_TYPE",
        mimeType,
        maxFileSize
      }
    });
  }

  if (selectedFile.size > maxFileSize) {
    throw new Error("File size exceeds the expected size. Please select a smaller file.", {
      cause: {
        type: "MAX_FILE_SIZE",
        mimeType,
        maxFileSize
      }
    });
  }
};
